import React from 'react';
import MasterPageAbstract from './master-page-abstract';
import { MasterPageType } from '../../constants/top-bar-constants';
import SideBar from 'modules/settings/components/side-bar';
import SectionChangePassword from 'modules/settings/components/section-change-password';
import SectionLanguageSelector from 'modules/settings/components/section-language-selector';
import SectionOptions from 'modules/settings/components/section-options';
import SectionAutoAnswer from 'modules/settings/components/section-auto-answer';
import SectionAdvancedTelephony from 'modules/settings/components/section-advanced-telephony';
import SectionKeyboardShortcuts from 'modules/settings/components/section-keyboard-shortcuts';
import SectionNotificationsAndAlerts from 'modules/settings/components/section-notifications-and-alerts';
import SectionGeolocationMap from 'modules/settings/components/section-geolocation-map';
import SectionMyBusiness from 'modules/settings/components/section-my-business';

/**
 * The master page linked with the Settings menu action.
 * @return {JSX.Element}
 * @constructor
 */
export default function MasterPageSettings() {
    return (
        <MasterPageAbstract
            masterPageType={MasterPageType.SETTINGS}
            sideBarContent={<SideBar />}
            mainAreaContent={
                <>
                    <SectionChangePassword />
                    <SectionLanguageSelector />
                    <SectionOptions />
                    <SectionAutoAnswer />
                    <SectionAdvancedTelephony />
                    <SectionKeyboardShortcuts />
                    <SectionNotificationsAndAlerts />
                    <SectionGeolocationMap />
                    <SectionMyBusiness />
                </>
            }
        />
    );
}
